import { IBoProperty } from '../bodisplay/dynamictags-inline/dynamictags-inline.model';
import { QueovalBase, QueovalDateTime, QueovalDate, QueovalDik } from '../global';
import { Person, Corporation, Invoice, ActionCoHistory, ActionCoReply, ActionCoTypeDevis } from './action-co.model';

export class ActionCoCardModel extends QueovalBase {
  public error: boolean;
  public idActionCo: string;
  public Sujet: string;
  public Description: string;
  public DescriptionRequired: boolean;
  public Priorite: string;
  public IsCloture: boolean;
  public InfoProjet: string;  
  public Date: QueovalDateTime;
  public requiredProps: Array<IBoProperty<any>>;
  public DateMinutesList: Array<string>;
  public TypesList: Array<QueovalDik>;
  public Amount: string;
  public PricePonderation: number;
  public Ponderation: number;
  public Type: string;
  public TypeDevis: string;
  public Status: string;
  public Remark: string;
  public Reason: string;
  public ReasonsList: Array<QueovalDik>;
  public lockThumb: boolean;

  public IdCollabo: string;
  public NameCollabo: string;

  public Collaborateurs: Array<Person>;
  public LogoCollabo: string;

  public Customer: Corporation;

  public ContactPrincipal: Person;

  public Contacts: Array<Person>;
  public Invoice: Invoice;

  public BoTypeValueSelected: string;

  // NOUVEAU MODELE (historique récupéré pour la création d'une action co)
  public ActionCoHistory: ActionCoHistory;

  public HistoryNewComment: string;

  public reply: ActionCoReply;
  constructor() {
    super();
    this.idActionCo = '';
    const dateNow = new Date(Date.now());
    this.Date = new QueovalDateTime(dateNow.getFullYear().toString(), `${dateNow.getMonth() + 1}`, dateNow.getDate().toString(), '00', '00');
    this.requiredProps = new Array<IBoProperty<any>>();

    this.DescriptionRequired = false;

    this.Reason = '';

    this.IdCollabo = '';
    this.NameCollabo = '';
    this.Collaborateurs = [];
    this.LogoCollabo = '';

    this.Customer = new Corporation();

    this.ContactPrincipal = new Person();

    this.Contacts = [];

    this.Invoice = new Invoice();

    /*this.History = [];*/
    this.reply = new ActionCoReply();
  }

  public getLabelTypeDevis(): string {
    let Sujet: string = "";
    switch (this.TypeDevis) {
      case ActionCoTypeDevis.CAC:
        Sujet = "Commissariat aux comptes";
        break;
      case ActionCoTypeDevis.Devis:
        Sujet = "Devis";
        break;
      case ActionCoTypeDevis.Produit:
        Sujet = "Devis Produit";
        break;
      case ActionCoTypeDevis.lettreDeMission:
        Sujet = "Lettre de mission";
        break;
    }
    return Sujet;
  }
}

